export function WalletMoney({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.25 3.375H12C12.1795 3.375 12.3195 3.38236 12.4395 3.40234L12.457 3.40527L12.4756 3.40723C13.7706 3.55907 14.6607 4.36007 14.917 5.58789H14.1904C13.2832 5.58789 12.4246 5.93541 11.7988 6.57227C11.0666 7.28528 10.7013 8.28751 10.7881 9.29004V9.29102C10.944 11.0625 12.4864 12.4121 14.2803 12.4121H14.915C14.7817 13.0442 14.4885 13.5474 14.084 13.9092C13.5924 14.3487 12.8909 14.625 12 14.625H5.25C3.59421 14.625 2.25 13.2808 2.25 11.625V6.375C2.25 5.50787 2.50942 4.82133 2.9248 4.33398C3.33866 3.84843 3.94775 3.51302 4.73633 3.41406L4.74609 3.41309L4.75684 3.41113C4.91168 3.38733 5.07587 3.375 5.25 3.375Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M16.4999 8.22789V9.77289C16.4999 10.1854 16.1699 10.5229 15.7499 10.5379H14.2799C13.4699 10.5379 12.7274 9.94539 12.6599 9.13539C12.6149 8.66289 12.7949 8.22039 13.1099 7.91289C13.3874 7.62789 13.7699 7.46289 14.1899 7.46289H15.7499C16.1699 7.47789 16.4999 7.81539 16.4999 8.22789Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
